import React, { FC } from 'react';
import { IconProps } from '.';

export const AttentionIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...sizing} {...props}>
            <path
                fill="currentColor"
                d="M12.5 5.64h-1a.67.67 0 0 0-.67.7l.53 8.2a.65.65 0 0 0 1.28 0l.53-8.2a.67.67 0 0 0-.67-.7Z"
            />
            <circle cx="12" cy="17.39" r="1.03" fill="currentColor" />
        </svg>
    );
};
